const RepostAnimation = {
    mounted() {
        this.wasReposted = this.el.querySelector('[data-reposted="true"]') !== null;
    },

    updated() {
        const isNowReposted = this.el.querySelector('[data-reposted="true"]') !== null;
        // Only animate if state changed from not-reposted to reposted
        if (!this.wasReposted && isNowReposted) {
            const icon = this.el.querySelector('[data-reposted="true"]');
            if (icon) {
                // Add animation class
                icon.classList.add("repost-spin");

                // Remove it after animation completes
                setTimeout(() => {
                    icon.classList.remove("repost-spin");
                }, 600);
            }
        }

        // Update state for next update
        this.wasReposted = isNowReposted;
    },
};

export default RepostAnimation;
